<template lang="pug">
GenericCard(size='40')
  .px-4.py-4
    .text-title บันทึกข้อมูลการเข้าเยี่ยม
  hr.m-0

  template(v-if='isSubmitted === false')
    .checkin.px-4.py-4
      GenericCard(size='22')
        .d-flex.flex-column.justify-content-center(
          style='height: 16vw;'
        )
          input.upa-img-input.w-100(
            ref="image-input"
            type="file"
            accept="image/*;capture=camera"
            capture='camera'
            @change="loadFileBase64"
          )

      template(v-if="fileBase64 !== ''")
        p.text-center ตัวอย่างรูปภาพ
        img.w-100(:src="fileBase64" style="border-radius: 8px; max-height: 240px;")

      button.btn.btn-upa-secondary.mx-auto.mb-2.mt-4(
        @click='submitLocation' :disabled="isSubmitting || fileBase64 === ''")
        template(v-if="isSubmitting"): .spinner-border
        template(v-else) บันทึก

  template(v-else)
    .submitted.d-flex.flex-column
      .response-message
        img(src='@/assets/icons/success.svg')
        .text-large.mt-3
          | คุณอัพโหลดภาพสำเร็จแล้ว

</template>

<script>
export default {
  props: {
    customer: {
      default: () => ({}),
    },
  },
  data: () => ({
    fileBase64: '',
    isSubmitting: false,
    isSubmitted: false,
  }),
  methods: {
    async submitLocation() {
      this.isSubmitting = true;

      const formData = new FormData();
      const fileRef = this.$refs['image-input'];
      formData.append('image', fileRef.files[0]);

      const res = await this.$api.customer.history.checkinByImg(
        this.customer.id,
        formData,
      );
      console.log(res);
      // TODO: actually implement the submitting part
      this.isSubmitted = true;
    },
    loadFileBase64() {
      const fileRef = this.$refs['image-input'].files[0];
      const reader = new FileReader();

      reader.addEventListener('load', () => {
        // convert image file to base64 string
        this.fileBase64 = reader.result;
      }, false);

      if (fileRef) {
        reader.readAsDataURL(fileRef);
      }
    },
  },
};
</script>

<style lang="scss">
.checkin {
  background: #FAFAFA;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;
}
.response-message {
  min-height: 360px;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;
}
</style>
